import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import * as Icons from 'lucide-react';
import { Check, ArrowRight } from 'lucide-react';
import { appliances } from '../mock';
import { Button } from './ui/button';

const tints = ['bg-[#FFEDD6]', 'bg-[#FCE0EC]', 'bg-[#E8DDFF]', 'bg-[#FFE0D6]'];

const ApplianceBrands = () => {
  const [selected, setSelected] = useState([]);

  const toggle = (id) => {
    setSelected((s) => (s.includes(id) ? s.filter((x) => x !== id) : [...s, id]));
  };

  const clearAll = () => setSelected([]);

  const quoteLink = selected.length > 0 ? `/quote?items=${selected.join(',')}` : '/quote';

  return (
    <section className="py-16 md:py-24 bg-white">
      <div className="max-w-7xl mx-auto px-5">
        <div className="grid lg:grid-cols-12 gap-10 items-start">
          <div className="lg:col-span-5 lg:sticky lg:top-24">
            <div className="text-xs uppercase tracking-[0.22em] font-bold text-[#FF5C39] mb-3">Choose your cover</div>
            <h2 className="text-4xl md:text-5xl font-bold text-[#1F0068] tracking-tight leading-[1.05]">
              Appliance cover for over <span className="text-[#FF5C39]">100 brands</span>
            </h2>
            <p className="mt-5 text-lg text-[#1F0068]/70 leading-relaxed">
              Tick as many appliances as you’d like to protect — we’ll cover them all under one simple annual plan.
            </p>

            <div className="mt-6 bg-[#FFF6EB] rounded-2xl p-5 border border-[#1F0068]/5">
              <div className="flex items-center justify-between">
                <div>
                  <div className="text-xs uppercase tracking-widest text-[#1F0068]/60 font-bold">Selected</div>
                  <div className="text-3xl font-extrabold text-[#1F0068]">{selected.length}</div>
                  <div className="text-xs text-[#1F0068]/60">Billed annually · all included</div>
                </div>
                {selected.length > 0 && (
                  <button onClick={clearAll} className="text-xs font-semibold text-[#FF5C39] hover:underline">Clear all</button>
                )}
              </div>
              <Link to={quoteLink}>
                <Button className="mt-4 w-full h-12 rounded-full bg-[#1F0068] hover:bg-[#2A0C7A] text-white font-semibold">
                  Get an annual quote <ArrowRight className="w-4 h-4 ml-1" />
                </Button>
              </Link>
              <p className="text-[10px] text-[#1F0068]/50 mt-2 text-center">Prices confirmed at quote stage. No monthly amounts shown — billed once, annually.</p>
            </div>
          </div>

          <div className="lg:col-span-7">
            <div className="grid grid-cols-2 sm:grid-cols-3 gap-3 md:gap-4">
              {appliances.map((a, i) => {
                const Ico = Icons[a.icon] || Icons.Package;
                const sel = selected.includes(a.id);
                return (
                  <button key={a.id} type="button" onClick={() => toggle(a.id)}
                    className={`dhs-card relative rounded-2xl p-5 text-center border-2 transition-all ${sel ? 'border-[#1F0068] bg-[#FFEDD6]' : 'border-transparent bg-[#FFF6EB] hover:border-[#1F0068]/20'}`}>
                    {sel && (
                      <span className="absolute top-3 right-3 w-6 h-6 rounded-full bg-[#00b67a] text-white flex items-center justify-center">
                        <Check className="w-3.5 h-3.5" />
                      </span>
                    )}
                    <div className={`w-14 h-14 mx-auto rounded-2xl ${tints[i % 4]} flex items-center justify-center text-[#1F0068] mb-3`}>
                      <Ico className="w-7 h-7" />
                    </div>
                    <div className="text-sm font-semibold text-[#1F0068]">{a.name}</div>
                  </button>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ApplianceBrands;
